import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AI_RUN_STATUSES } from "@/api/types";
import { AiPage } from "@/features/ai/ai-page";
import { baseListSearch, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/ai/")({
  validateSearch: z.object({
    ...baseListSearch,
    status: optionalEnum(AI_RUN_STATUSES),
    model: optionalString,
    provider: optionalString,
    promptVersion: optionalString,
    organizationId: optionalString,
    storeId: optionalString,
    range: optionalEnum(["24h", "7d", "30d", "90d"] as const),
    preview: optionalString,
  }),
  head: () => ({ meta: [{ title: "AI Operations · Rogue Admin" }] }),
  component: AiPage,
});
